module.exports = __webpack_public_path__ + "static/media/Z8.2f5dad4f.jpg";